.collapseContainer {
	background-color: #ffffff;
	border-radius: 12px;
	border: 1px solid #ededed;
	display: flex;
	flex-direction: column;
	gap: 0.5rem;
	align-items: flex-start;
}

.editQuizExpandButton:global(.MuiButton-root) {
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	width: 100%;
	padding: 0.9375rem;
	border-radius: inherit;

	&:hover {
		background-color: #fafafa;
	}

	&:focus-visible {
		outline: none;
		outline-offset: 0;
		border: 1px solid var(--focus-outline-color-dark);
	}
}

.expandedContent {
	width: 100%;
	padding: 0 0.9375rem 0.9375rem 0.9375rem;
	box-sizing: border-box;
}

.summaryWrapper {
	display: flex;
	flex-direction: row;
	gap: 0.75rem;
	align-items: flex-start;
	width: 100%;
}

.titleWrapper {
	display: flex;
	flex-direction: column;
	gap: 0.25rem;
	align-items: flex-start;
	width: 100%;

	& .title:global(.MuiTypography-root) {
		color: #212121;
		font-weight: 600;
		font-size: 0.875rem;
		line-height: 1.6;
		letter-spacing: -0.43px;
	}

	& .description:global(.MuiTypography-root) {
		color: #6b6b6b;
		font-weight: 400;
		font-size: 0.8125rem;
		line-height: 1.6;
		letter-spacing: -0.08px;
	}
}

.viewMoreButton:global(.MuiButton-root) {
	border: 1px solid #874bd3;
	border-radius: 10px;
	background-color: #fff;
	width: 100%;
	height: 40px;
	padding: 1rem 0.5rem;
	justify-content: center;
	align-items: center;
	display: flex;
	flex-direction: row;
	gap: 0.5rem;
}

.viewMoreText:global(.MuiTypography-root) {
	color: #874bd3;
	font-weight: 600;
	font-size: 0.9375rem;
	line-height: 1.5;
}

@media (max-width: 768px) {
	.summaryWrapper {
		flex-direction: column;
		align-items: center;
	}

	.titleWrapper {
		align-items: center;
	}
}
